import React, { useEffect, useRef, useState } from "react";
import {
  HiringPartnersImg,
  InDemandLinksImg,
  LearnersImg,
  RewardImg,
} from "../LandingPage/imageLinks";
import Logo from "../OnboardingRevampPage/Logo";
import { IKImage } from "imagekitio-react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEye, faEyeSlash, faStar } from "@fortawesome/free-solid-svg-icons";
import FooterLandingPage from "../LandingPage/FooterLandingPage";
import "./index.css";
import { useDispatch } from "react-redux";
import { setUserPassword } from "../../redux/actions/authentication";
import { toast } from "react-toastify";
import { useNavigate } from "react-router";
import { useSearchParams } from "react-router-dom";

const PasswordReset = () => {
  const [isEnter, setIsEnter] = useState(false);
  const [isConfirmEnter, setIsConfirmEnter] = useState(false);

  const [isEnterValue, setIsEnterValue] = useState("");
  const [isConfirmEnterValue, setIsConfirmEnterValue] = useState("");

  const [isChanged, setIsChanged] = useState(false);
  const [loading, setLoading] = useState(false);
  const [failed, setFailed] = useState(false);
  const buttonStates = {
    state1: "Change Password",
    state2: "Changing Password",
    state3: "Password Doesn’t Match! Try Again.",
    state4: "Min. 8 characters Required!.Try Again",
  };
  const dispatch = useDispatch();
  const [displayButton, setDisplayButton] = useState(buttonStates?.state1);
  const [isSubmit, setIsSubmit] = useState(false);
  const scrollRef = useRef();
  const [countDown, setCountDown] = useState(5);
  const navigate = useNavigate();
  const [searchParams, setSearchParams] = useSearchParams();
  let interval;

  useEffect(() => {
    if (window.innerWidth < 768)
      setTimeout(() => {
        if (scrollRef?.current) {
          scrollRef?.current?.scrollIntoView({ behaviour: "smooth" });
        }
      }, 2000);
  }, []);

  useEffect(() => {
    if (isChanged) {
      interval = setInterval(() => {
        setCountDown((prevCountdown) => prevCountdown - 1);
      }, 1000);
    }

    return () => clearInterval(interval);
  }, [isChanged]);

  useEffect(() => {
    if (countDown <= 0) {
      navigate("/courses");
    }
  }, [countDown]);
  function onSubmit() {
    setLoading(true);
    setIsSubmit(true);
    if (isEnterValue !== isConfirmEnterValue) {
      setDisplayButton(buttonStates?.state3);
      setLoading(false);
    } else if (isEnterValue?.length < 8) {
      setDisplayButton(buttonStates?.state4);
      setLoading(false);
    } else {
      setDisplayButton(buttonStates?.state2);
      dispatch(
        setUserPassword(
          searchParams?.get("token"),
          isEnterValue,
          (successObj) => {
            setIsChanged(true);
            setLoading(false);
          },
          (errorObj) => {
            toast.error("Somthing went wrong!!");
            setDisplayButton(buttonStates?.state1);
            setLoading(false);
          },
        ),
      );
    }
  }

  const spinner = () => {
    return (
      <div
        className={`mr-1 h-4  w-4 animate-spin rounded-full border-2 border-white border-t-transparent`}
      ></div>
    );
  };
  return (
    <div
      className="flex  w-full flex-col items-center justify-start overflow-x-clip text-white"
      style={{
        background:
          "radial-gradient(50% 50% at 50% 50%, #26496A 0%, #182C3F 100%)",
      }}
    >
      <div
        className={`mt-4 flex w-full items-center justify-center gap-4 px-7 md:px-16`}
      >
        <Logo />
      </div>
      <div className="flex w-full flex-col md:flex-row">
        <div className="w-full md:ml-36 md:px-10">
          <h2 className="mt-8 px-3 text-center text-[32px] font-semibold leading-10 md:mt-14 md:w-[90%] md:text-left md:text-[44px] md:leading-[3rem]">
            <span className="text-[#00C1FF]">Get Certified </span>By Learning{" "}
            <span className="text-[#00C1FF]">200+ Skills For Free </span> on
            YouTube.
          </h2>
          <div className="mt-10">
            <div className="flex flex-col items-center justify-start md:flex-row">
              <div className="flex">
                {InDemandLinksImg?.map((item) => (
                  <img
                    urlEndpoint="https://img.learntube.ai/public-assets/"
                    className="mx-0.5 h-6 w-6 md:h-6 md:w-6"
                    src={item}
                    loading="eager"
                    transformation={[
                      {
                        height: "26",
                        width: "26",
                      },
                    ]}
                  />
                ))}
              </div>
              <p className="ml-4 font-semibold md:text-xl">
                210+ In-Demand Skills
              </p>
            </div>
            <div className="mt-4 flex flex-col items-center justify-start md:flex-row">
              <div className="flex">
                {LearnersImg.map((item) => (
                  <img
                    urlEndpoint="https://img.learntube.ai/public-assets/"
                    className="mx-0.5 h-6 w-6 rounded-full md:h-6 md:w-6"
                    src={item}
                    loading="eager"
                    transformation={[
                      {
                        height: "26",
                        width: "26",
                      },
                    ]}
                  />
                ))}
              </div>
              <p className="ml-4 font-semibold md:text-xl">
                8,00,000+ Learners
              </p>
            </div>
            <div className="mt-4 flex flex-col items-center justify-start md:flex-row">
              <div className="flex ">
                {HiringPartnersImg?.map((item, index) => (
                  <img
                    urlEndpoint="https://img.learntube.ai/public-assets/"
                    className="mx-0.5 h-6 w-6 md:h-6 md:w-6 "
                    src={item}
                    loading="eager"
                    transformation={[
                      {
                        height: "26",
                        width: "26",
                      },
                    ]}
                  />
                ))}
              </div>
              <p className="ml-4 font-semibold md:text-xl">
                1100+ Hiring Partners
              </p>
            </div>
            <div className="mt-4 flex flex-col items-center justify-start md:flex-row">
              <div className="flex">
                <FontAwesomeIcon
                  icon={faStar}
                  className="mx-0.5 h-6 w-6 text-yellow-500 md:h-6 md:w-6"
                />
                <FontAwesomeIcon
                  icon={faStar}
                  className="mx-0.5 h-6 w-6 text-yellow-500 md:h-6 md:w-6"
                />
                <FontAwesomeIcon
                  icon={faStar}
                  className="mx-0.5 h-6 w-6 text-yellow-500 md:h-6 md:w-6"
                />
                <FontAwesomeIcon
                  icon={faStar}
                  className="mx-0.5 h-6 w-6 text-yellow-500 md:h-6 md:w-6"
                />
                <FontAwesomeIcon
                  icon={faStar}
                  className="mx-0.5 h-6 w-6 text-yellow-500 md:h-6 md:w-6"
                />
              </div>
              <p className="ml-4 font-semibold md:text-xl">
                4.8/5 Average Course Rating
              </p>
            </div>
            <div className="mt-4 flex flex-col items-center justify-start md:flex-row">
              <div className="flex">
                {RewardImg?.map((item) => (
                  <img
                    urlEndpoint="https://img.learntube.ai/public-assets/"
                    className="mx-0.5 h-6 w-6 md:h-6 md:w-6"
                    src={item}
                    transformation={[
                      {
                        height: "26",
                        width: "26",
                      },
                    ]}
                  />
                ))}
              </div>
              <p className="ml-4 font-semibold md:text-xl">
                Unlock Rs. 1 Lakh+ Rewards
              </p>
            </div>
          </div>
        </div>
        <div className="flex w-full flex-col items-center">
          <div
            className="mt-16 flex w-[93%] flex-col rounded-lg border-2 border-[#1CB05E] bg-[#2D4F71] p-4 md:mt-20 md:w-[70%]"
            style={{
              boxShadow: "0px 0px 10px 0px #1CB05E",
            }}
          >
            {!isChanged ? (
              <>
                <h2 className=" text-[20px] font-semibold text-white ">
                  Change Password
                </h2>
                <h3
                  className="text-[16px] font-semibold"
                  style={{ color: "rgba(255, 255, 255, 0.80)" }}
                >
                  Set a new password for your account
                </h3>
                <div className="mt-6 flex w-full flex-col justify-center text-gray-500">
                  <label
                    htmlFor="password"
                    className="  text-[16px] font-semibold text-[#FFF]"
                  >
                    New Password
                  </label>
                  <div className="mt-1 flex h-[44px] w-full ">
                    <input
                      className="password-input w-full rounded-tl-lg rounded-bl-lg bg-[#223548] py-2 px-4 text-white"
                      type={isEnter ? "text" : "password"}
                      placeholder="Create a new password"
                      value={isEnterValue}
                      onChange={(e) => setIsEnterValue(e.target.value)}
                    ></input>
                    <FontAwesomeIcon
                      icon={isEnter ? faEyeSlash : faEye}
                      className="cursor-pointer  rounded-tr-lg rounded-br-lg bg-[#223548] p-3.5 text-[#7FC241]"
                      onClick={(e) => setIsEnter(!isEnter)}
                    />
                  </div>
                  <label
                    htmlFor="password"
                    className=" mt-3 text-[16px] font-semibold text-[#FFF]"
                  >
                    Confirm Password
                  </label>
                  <div className="mt-1 flex h-[44px] w-full ">
                    <input
                      className="password-input  w-full rounded-tl-lg rounded-bl-lg bg-[#223548] py-2 px-4 text-white"
                      type={isConfirmEnter ? "text" : "password"}
                      placeholder="Confirm password"
                      value={isConfirmEnterValue}
                      onChange={(e) => setIsConfirmEnterValue(e.target.value)}
                    ></input>
                    <FontAwesomeIcon
                      icon={isConfirmEnter ? faEyeSlash : faEye}
                      className="cursor-pointer rounded-tr-lg rounded-br-lg bg-[#223548] p-3.5 text-[#7FC241]"
                      onClick={(e) => setIsConfirmEnter(!isConfirmEnter)}
                    />
                  </div>
                  <button
                    className={`mt-4 flex w-full items-center justify-center rounded-lg py-2 px-2 text-center text-white disabled:opacity-[50%] ${
                      displayButton === buttonStates?.state3 ||
                      displayButton === buttonStates?.state4
                        ? "bg-[#E06064]"
                        : "bg-[#13B284]"
                    }`}
                    disabled={
                      !(
                        isEnterValue?.length > 0 &&
                        isConfirmEnterValue?.length > 0
                      ) || loading
                    }
                    onClick={(e) => onSubmit()}
                  >
                    {" "}
                    {loading && spinner()}
                    {displayButton}
                  </button>
                </div>
              </>
            ) : (
              <div className="flex flex-col items-center justify-center">
                <img
                  urlEndpoint="https://img.learntube.ai/public-assets/"
                  src="https://img.learntube.ai/public-assets/Onboarding_Revamp/Group%2010101.svg?updatedAt=1703742405229"
                  className="w-1/2"
                  transformation={[
                    {
                      height: "50",
                      width: "50",
                    },
                  ]}
                />
                <div className="text-[20px] font-semibold">
                  Password Changed Successfully
                </div>
                <div
                  className="countdown-text text-[16px] font-medium"
                  style={{ color: "rgba(255, 255, 255, 0.80)" }}
                >
                  You’ll be redirected to home in {countDown}
                  <span className="dot-1">.</span>
                  <span className="dot-2">.</span>
                  <span className="dot-3">.</span>
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
      <div className="mt-20 w-full" ref={scrollRef}>
        <FooterLandingPage />
      </div>
    </div>
  );
};

export default PasswordReset;
